// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"ffbadc00","510":"3a253d55","787":"f9536e54"}[chunkId] + ".chunk.js";
};